<template>
  <div class="loading">
    <div class="loadEffect">
      <van-loading :size="size"></van-loading>
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '加载中...'
    },
    size: {
      type: [String, Number],
      default: 30
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-loading {
  width: 50px;
  height: 50px;
}
.loading {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadEffect {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  position: relative;
  margin: -120px auto 0;
  background: rgba(58, 59, 63, 0.9);
  border-radius: 5px;
  color: #fff;
}

.loading-text {
  font-size: 20px;
  color: #ffffff;
  margin-top: 12px;
}
</style>
